import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom-v5-compat'
import { InfoButton } from 'components/buttons'
import { Form, Input } from 'components/forms'
import HolidayPresent from 'shared/svg/holiday-present.svg'
import Slide from '../slide/slide'

interface HolidayInputOtherProps {
  onSubmit: (data: any) => void
  nextPath: string
}

export const HolidayInputOther = ({
  nextPath,
  onSubmit,
}: HolidayInputOtherProps) => {
  const { register, handleSubmit, errors, watch } = useForm()
  const holidayNameValue = watch('holiday_name')

  const navigate = useNavigate()

  const handleOnSubmit = (data: Record<string, any>) => {
    onSubmit({ list_sub_type: data.holiday_name })
    navigate(nextPath)
  }
  return (
    <Slide title="What are you celebrating?">
      <p>
        <HolidayPresent />
      </p>

      <Form onSubmit={handleSubmit(handleOnSubmit)}>
        <Input
          error={errors?.holiday_name?.message}
          inputRef={register({
            required: 'Please enter a holiday name',
          })}
          name="holiday_name"
          placeholder="Example: Festivus"
          type="text"
        />
        <InfoButton
          block
          pill
          aria-label="submit"
          className="mbl"
          disabled={!holidayNameValue || !!Object.keys(errors).length}
          type="submit"
        >
          Next
        </InfoButton>
      </Form>
    </Slide>
  )
}
